import advanceTransformer from '@/transformers/purchase/advanceByPurchase'
import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Send an advance
 *
 * @param  payload Advance's info
 * @param  purchase Purchase's id
 * @return {Array} Advance's info
 */

const createAdvanceByPurchase = (payload, purchase) =>
  Vue.$http.post(`purchase/order/${purchase}/advance_request/`, advanceTransformer.send(payload))
    .then()
    .catch((err) => {
      throw err
    })

export default createAdvanceByPurchase


// WEBPACK FOOTER //
// ./src/services/purchase/advance/createAdvanceByPurchase.js